/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Reducers
 */
import application from './application/reducer';
import currentUser from './current-user/reducer';
import documentHead from './document-head/reducer';
import login from './login/reducer';
import notices from './notices/reducer';
import preferences from './preferences/reducer';
import ui from './ui/reducer';
import connections from './connections/reducer';
import connectionTypes from './connection-types/reducer';
import resources from './resources/reducer';
import locationGroups from './location-groups/reducer';
import locations from './locations/reducer';
import connectionLocations from './connection-locations/reducer';
import terminals from './terminals/reducer';
import paytypes from './paytypes/reducer';
import locationWebsites from './location-websites/reducer';
import images from './images/reducer';
import connectionWebhooks from './connection-webhooks/reducer';
import connectionPaymentTypes from './connection-payment-types/reducer';
import connectionSalesTypes from './connection-sales-types/reducer';

// Please keep this list alphabetized!
const reducers = {
    application,
    currentUser,
    connections,
    connectionTypes,
    documentHead,
    login,
    locations,
    locationGroups,
    locationWebsites,
    notices,
    resources,
    preferences,
    ui,
    connectionLocations,
    terminals,
    paytypes,
    images,
    connectionWebhooks,
    connectionPaymentTypes,
    connectionSalesTypes
};

export default combineReducers(reducers);
